
/***



	Todo:


		(okt 25)


			[x] nieuw board ook gelijk toevoegen aan lokale lijst


			[ ] harde vars naar .env verplaatsen

				[ ] boards url (naar werkelijke app omgeving)

				[ ] url voor (puur) data


			[ ] comments en test data opruimen

*/
import React, { 
	useEffect, 
	useState, 
	useRef 
} 							from 'react';

import { useAuth } 			from "../context/AuthContext";

import ProjectCard 			from "../components/ProjectCard"; 

import { 
	Home, 
	FileText, 
	Star 
} 							from 'lucide-react'; 



export default function Dashboard() {

	const { token } 					= useAuth();

	const reclayBaseUrl					= process.env.REACT_APP_PUBLIC_RECLAY_BASE_URL + "?folder=../js/apps/directDraw/applications&appName=APP_miroClone";
	const reclayDataUrl					= process.env.REACT_APP_PUBLIC_RECLAY_DATA_URL;


	const [boards, setBoards] 			= useState([]);

	const [loading, setLoading] 		= useState(true);

	const [renameModalOpen, setRenameModalOpen] = useState(false);
	const [renameProjectId, setRenameProjectId] = useState(null);
	const [newTitle, setNewTitle] = useState("");




	const fetchProjects = async () => {

		console.log('fetchProjects called');

		// Wait for the token ...
		if( ! token ) 		return;


		const formData = new FormData();
		formData.append("action", "getProjects");
		formData.append("changes", "{}");


		try {

			const res = await fetch( 

				reclayDataUrl, 

				{
					method: 			'POST',
					
					// [ ] todo: nodig als we $session in backend willen gebruiken
					// credentials: 'include', // nodig als je cookies of sessies gebruikt
					
					body: 				formData,

					headers: 			{
											'Authorization': `Bearer ${token}`,
											// let op: als je formData gebruikt, **niet** de content-type instellen, browser doet dat automatisch
										},
				}
			)

			if (res.ok) {

				const data = await res.json();

				setBoards(data); // zet de data in state

			}

			setLoading(false);

		} catch (err) {

			console.error(err);

			setLoading(false);

		}

	};




	useEffect(

		() => {

			console.log('useEffect mount: canvas initialized');

			fetchProjects();

		},

		[token]				// <-- useEffect will run again when token becomes available
	);







	const handleBoardClick 	= ( projectId ) => {

		console.log('handle board click');

		/*

			(okt 25)

				[x] voor token moeten we AuthContext.js gebruiken (ipv window.token)
		
				[ ] moeten we nog checken/wachten op token? in de praktijk zal die altijd geladen zijn als de gebruiker klikt!

		*/
		var url						= `${reclayBaseUrl}&projectId=${projectId}&token=${token}`;
		
		window.location.href 		= url;
	};



	const createNewProject = async () => {

		const formData 				= new FormData();

		const params				= JSON.stringify( {"title": "untitled"} );

		formData.append("action", "createProject");
		formData.append("changes", params);


		try {

			const res = await fetch( 

					reclayDataUrl, 

					{
						method: 			'POST',
						
						// [ ] todo: nodig als we $session in backend willen gebruiken
						// credentials: 'include', // nodig als je cookies of sessies gebruikt
						
						body: 				formData,

						headers: 			{
												'Authorization': `Bearer ${token}`,
												// let op: als je formData gebruikt, **niet** de content-type instellen, browser doet dat automatisch
											},
					}
				)

			if (res.ok) {

				const text = await res.text();

				let newBoard = null;


				try {

					const data = JSON.parse(text);


					if (data && typeof data === 'object') {

						if (data.id) {

							newBoard = {

								id: 		data.id,
								title: 		data.title || "untitled"

							};

						} else if (data.projectId) {

							newBoard = {

								id: 		data.projectId,
								title: 		data.title || "untitled"

							};

						}

					} else if (data && (typeof data === 'string' || typeof data === 'number')) {

						newBoard = {

							id: 			data,
							title: 			"untitled"

						};

					}

				} catch (e) {

					console.warn("Could not parse project creation response as JSON. Falling back to refetching all projects.", e);

					// Fallback: fetch all projects from the backend
					fetchProjects();

					return;

				}


				if (newBoard) {

					setBoards(prevBoards => [...prevBoards, newBoard]);

					openRenameDialog(newBoard.id, newBoard.title);

				} else {

					// If newBoard couldn't be constructed but we got success, fallback to fetching
					fetchProjects();

				}

			}

		} catch (err) {

			console.error(err);

		}

	};


	
	const deleteProject = async ( projectId ) => {

		console.log('delete project ', projectId );

		const formData 		= new FormData();

		const params		= JSON.stringify( { "id": projectId } );
		formData.append("action", "deleteProject");
		formData.append("changes", params);


		try {

			const res = await fetch( 

					reclayDataUrl, 

					{
						method: 			'POST',
						
						// [ ] todo: nodig als we $session in backend willen gebruiken
						// credentials: 'include', // nodig als je cookies of sessies gebruikt
						
						body: 				formData,

						headers: 			{
												'Authorization': `Bearer ${token}`,
												// let op: als je formData gebruikt, **niet** de content-type instellen, browser doet dat automatisch
											},
					}
				)

			if (res.ok) {

				setBoards(prevBoards => prevBoards.filter(board => board.id !== projectId));

			}

		} catch (err) {

			console.error(err);

		}

	};



	const openRenameDialog = ( projectId, currentTitle ) => {

		setRenameProjectId( projectId );
		setNewTitle( currentTitle );
		setRenameModalOpen( true );
	};



	const renameProject = async ( projectId, title ) => {

		console.log('rename project ', projectId, title );


		const formData 		= new FormData();

		const params		= JSON.stringify( { "id": projectId, "title": title } );
		formData.append("action", "renameProject");
		formData.append("changes", params);


		try {

			const res = await fetch( 

					reclayDataUrl, 

					{
						method: 			'POST',
						
						// [ ] todo: nodig als we $session in backend willen gebruiken
						// credentials: 'include', // nodig als je cookies of sessies gebruikt
						
						body: 				formData,

						headers: 			{
												'Authorization': `Bearer ${token}`,
												// let op: als je formData gebruikt, **niet** de content-type instellen, browser doet dat automatisch
											},
					}
				)

			if (res.ok) {

				setBoards(prevBoards => prevBoards.map(board => board.id === projectId ? { ...board, title: title } : board));

				setRenameModalOpen(false);

			}

		} catch (err) {

			console.error(err);

		}

	};




	return (

		<div className="app">

			{/* Sidebar */}
			<aside className="sidebar">

				{/* <h2 className="logo"></h2> */}

				<button className="sidebar-fab" onClick={createNewProject}>
					<span className="fab-icon">+</span> New Board
				</button>
			
				<nav className="menu">
					<button className="menu-item">
						<Home size={20} />
						Home
					</button>
					<button className="menu-item" disabled>
						<FileText size={20} />
						Templates
					</button>
					<button className="menu-item" disabled>
						<Star size={20} />
						Favorites
					</button>
				</nav>
			
			</aside>



			{/* Main content */}
			<main className="main">

					{/* <header className="header">
						<h1>Your Boards</h1>
					</header> */}


					{/* Loading indicator */}
					{
						loading 
						? 
						(
						<div className="loading">Loading boards...</div>
						) 
						: 
						boards.length === 0 
						? 
						(
							<div className="empty-state-container">

								<div className="empty-state-card">

									<div className="empty-state-icon-wrapper">

										<div className="empty-state-icon">

											<div className="whiteboard-icon"></div>

										</div>

									</div>

									<h2 className="empty-state-title">No boards found</h2>

									<p className="empty-state-text">
										It looks like you haven't created any boards yet. Start by creating your first board!
									</p>

									<button className="empty-state-button" onClick={createNewProject}>
										<span className="button-icon">+</span> Create a new Board
									</button>

								</div>

							</div>
						) 
						: 
						(
							<section className="board-grid">
								{
									boards.map(
										
										(board) => (

											<ProjectCard
												key 				= { board.id }
												id					= { board.id }
												title				= { board.title }
												imageSrc			= { "/board.png"}

												onClick				= {() => handleBoardClick(board.id)}

												menuActions			= { 
																		{ 
																			delete: 	deleteProject,
																			rename: 	openRenameDialog
																		} 
																	}
											/>
										)
									)
								}
							</section>
						)
					}
			</main>

			{renameModalOpen && (
				<div 
					className			= "modal-overlay"
					onClick				= {() => setRenameModalOpen(false)}
				>
					<div 
						className		= "modal-card"
						onClick			= {(e) => e.stopPropagation()}
					>
						<h2 className="modal-title">Rename Board</h2>

						<input 
							type			= "text" 
							value			= {newTitle} 
							onChange		= {(e) => setNewTitle(e.target.value)}
							onKeyDown		= {(e) => {
												if (e.key === 'Enter') {
													renameProject(renameProjectId, newTitle);
												} else if (e.key === 'Escape') {
													setRenameModalOpen(false);
												}
											}}
							autoFocus
							className		= "modal-input"
						/>

						<div className="modal-actions">
							<button 
								onClick			= {() => setRenameModalOpen(false)}
								className		= "modal-btn-cancel"
							>
								Cancel
							</button>
							<button 
								onClick			= {() => renameProject(renameProjectId, newTitle)}
								className		= "modal-btn-primary"
							>
								Save
							</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
